/**
 * Bank Reconciliation Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const reconciliationAPI = {
  getAll: (params) => apiClient.get('/reconciliation', { params }),
  // When the latest reconciliation was completed, with a time-zone label.
  lastCompleted: (params) => apiClient.get('/reconciliation/last-completed', { params }),
  getById: (id) => apiClient.get(`/reconciliation/${id}`),
  getByAccount: (accountId) => apiClient.get(`/reconciliation/account/${accountId}`),
  start: (data) => apiClient.post('/reconciliation/start', data),
  addTransaction: (reconciliationId, transactionId) => apiClient.post(`/reconciliation/${reconciliationId}/transactions`, { transaction_id: transactionId }),
  removeTransaction: (reconciliationId, transactionId) => apiClient.delete(`/reconciliation/${reconciliationId}/transactions/${transactionId}`),
  complete: (id, data) => apiClient.post(`/reconciliation/${id}/complete`, data),
  delete: (id) => apiClient.delete(`/reconciliation/${id}`),
  // Monthly reconciliation (per account and month)
  monthlyStatus: (params) => apiClient.get('/reconciliation/monthly/status', { params }),
  getMonth: (accountId, month) => apiClient.get(`/reconciliation/monthly/${accountId}/${month}`),
  saveMonth: (accountId, month, data) => apiClient.put(`/reconciliation/monthly/${accountId}/${month}`, data),
  clearRows: (accountId, month, ids, cleared, clearedDates) => apiClient.post(`/reconciliation/monthly/${accountId}/${month}/clear`,
    clearedDates ? { transaction_ids: ids, cleared, cleared_dates: clearedDates } : { transaction_ids: ids, cleared }),
  reconcileMonth: (accountId, month) => apiClient.post(`/reconciliation/monthly/${accountId}/${month}/reconcile`, {}),
  reopenMonth: (accountId, month) => apiClient.post(`/reconciliation/monthly/${accountId}/${month}/reopen`, {}),
  readStatement: (accountId, month, file) => {
    const form = new FormData();
    form.append('file', file);
    return apiClient.post(`/reconciliation/monthly/${accountId}/${month}/statement`, form);
  },
  // Statement periods (per account, any start and end date)
  statementOverview: (accountId) => apiClient.get(`/reconciliation/statement/${accountId}`),
  setClosingDay: (accountId, closingDay) => apiClient.put(`/reconciliation/statement/${accountId}/closing-day`, { closing_day: closingDay }),
  createStatement: (accountId, data) => apiClient.post(`/reconciliation/statement/${accountId}`, data),
  getStatement: (accountId, id) => apiClient.get(`/reconciliation/statement/${accountId}/${id}`),
  saveStatement: (accountId, id, data) => apiClient.put(`/reconciliation/statement/${accountId}/${id}`, data),
  clearStatementRows: (accountId, id, ids, cleared, clearedDates) => apiClient.post(`/reconciliation/statement/${accountId}/${id}/clear`,
    clearedDates ? { transaction_ids: ids, cleared, cleared_dates: clearedDates } : { transaction_ids: ids, cleared }),
  reconcileStatement: (accountId, id) => apiClient.post(`/reconciliation/statement/${accountId}/${id}/reconcile`, {}),
  reopenStatement: (accountId, id) => apiClient.post(`/reconciliation/statement/${accountId}/${id}/reopen`, {}),
  getDatingMethod: (businessId) => apiClient.get(`/reconciliation/dating-method/${businessId}`),
  setDatingMethod: (businessId, method) => apiClient.put(`/reconciliation/dating-method/${businessId}`, { reconciliation_dating_method: method }),
  setOpeningBalance: (accountId, data) => apiClient.put(`/reconciliation/opening-balance/${accountId}`, data),
};

export default reconciliationAPI;

